import React, { useState, useRef, useEffect } from "react"
import PlayVideo from "./Play/PlayVideo"
import { Modal } from "react-bootstrap"
import ReactPlayer from "react-player"
import ModalVideo from "react-modal-video"
import { createPortal } from "react-dom"

import $ from "jquery"
import { isIOS, isMobileOnly, isBrowser, isMobile } from "react-device-detect"

const ModalWindow = ({ children }) => {
  // element to which the modal will be rendered
  const el = document.createElement("div")
  // add a class to the container div for styling
  // el.className = "modal-portal-container";
  useEffect(() => {
    const modalRoot = document.body
    // append to root when the children of Modal are mounted
    modalRoot.appendChild(el)
    // do a cleanup
    return () => {
      modalRoot.removeChild(el)
    }
  }, [el])

  return createPortal(children, el)
}

const GetVideo = props => {
  const [isOpen, setOpen] = useState(false)
  const [isPlay, setPlay] = useState(false)
  const [videoID, SetvideoID] = useState(false)

  const [videotype, setVideoType] = useState("youtube")
  const [youtubeid, setYoutubeID] = useState("youtube")

  const [video_url, setVideoURL] = useState("")

  function checkvideo(url) {
    let url_one = String(url)

    let youtube = url_one.indexOf("youtube.com") > -1
    let matter = url_one.indexOf("matterport.com") > -1
    let matter_model = url_one.indexOf("models") > -1
    if (youtube == true) {
      setVideoType("youtube")
      setYoutubeID(url_one.split("/").pop())
    } else if (matter == true) {
      setVideoType("matterport")
      if (matter_model) {
        if (url_one.split("/").pop()) {
          setVideoURL(
            "https://my.matterport.com/show/?m=" + url_one.split("/").pop()
          )
        }
      } else {
        setVideoURL(props.videoUrl[0])
      }
    }
  }

  const vidRef = useRef(null)
  const [show, setShow] = useState(false)
  const [play, setPlayvideo] = useState(true)
  const [mute, setMute] = useState(true)
  const [controls, setVideoControls] = useState(false)
  const [showHTMLVideo, setHTMLVideo] = React.useState(false)

  const trackerVideo = event => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Video Play Btn",
      formType: event,
      formId: "Video Play",
      formName: "Video",
      formLabel: "Video",
    })
  }

  const playvideo = ref => {
    setPlayvideo(true)
    setVideoControls(false)
    setTimeout(function () {
      $(".modal-bg-black").hide()
    }, 1700)
  }

  // const videoClick = value => {
  //   // props.handleClickVideo(value)
  // }

  return (
    <>
      {props.videoUrl?.length > 0 && (
        <>
          <span
            className="play-btn"
            tabIndex="0"
            onClick={() => {
              setHTMLVideo(true)
              playvideo()
              checkvideo(props.videoUrl[0])
              setShow(true)
              setOpen(true)
            }}
          >
            <strong className="video-arrow-video">
              <i className="video-icon"></i> <span>Video tour</span>
            </strong>
          </span>

          {isOpen && showHTMLVideo && videotype == "matterport" ? (
            <ModalWindow>
              <div className="matterPort-popup">
                <ModalVideo
                  channel="custom"
                  isOpen={isOpen}
                  url={`${video_url}&play=1`}
                  onClose={() => setOpen(false)}
                  autoplay={true}
                />
              </div>
            </ModalWindow>
          ) : isOpen && showHTMLVideo && videotype != "matterport" ? (
            <Modal
              show={show}
              onHide={() => setShow(false)}
              dialogClassName="modal-video"
              aria-labelledby="example-custom-modal-styling-title"
              backdropClassName="video-backdrop"
              className="area-guide-full-video-popup"
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                {isMobile && <div className="modal-bg-black"></div>}
                <ReactPlayer
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  ref={vidRef}
                  onPlay={trackerVideo(props.title)}
                  url={props.videoUrl[0]}
                  modestbranding="1"
                  controls={isMobile && isIOS ? true : false}
                  autoplay={true}
                  muted={isMobile && isIOS ? mute : false}
                  playsinline={true}
                  playing={play}
                  onEnded={() => {
                    setHTMLVideo(false)
                  }}
                  width="100%"
                  height="100%"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </>
      )}
    </>
  )
}

export default GetVideo
